const STREAK_NOTES = [
  'Lose streak!',
  'Correct',
  'Double streak!',
  'Triple streak!',
  'Four Streak!',
  'Awesome!',
  'Keep going!',
  'Amazing!',
  'Good job!',
]
const RANDOM_NOTE_AT_STREAK = 5

export default {
  data() {
    return {
      streakNote: '',
    }
  },
  mounted() {
    this.getStreakNote()
  },
  methods: {
    isLosingStreak(currentStreak, lastStreak) {
      return lastStreak > currentStreak
    },
    getStreakNote() {
      if (!this.result) return

      const { streak, lastStreak } = this.result

      if (this.isLosingStreak(streak, lastStreak)) {
        [this.streakNote] = STREAK_NOTES
      } else if (streak > 0 && streak < RANDOM_NOTE_AT_STREAK) {
        this.streakNote = STREAK_NOTES[streak]
      } else if (streak >= RANDOM_NOTE_AT_STREAK) {
        const max = STREAK_NOTES.length - 1
        const min = RANDOM_NOTE_AT_STREAK
        const index = Math.floor(
          (Math.random() * (max - min + 1) + min),
        )
        this.streakNote = STREAK_NOTES[index]
      } else {
        // enable setting streak => streak = 0
        this.streakNote = this.$t('Correct')
      }
    },
  },
}
